import React, { Component } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import Select from "react-select-plus";
import groupBy from "lodash/groupBy";
import Search from "material-ui/svg-icons/action/search";

import "./industry-dialog.css";

class Industry extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
      industryGroupObj: [{ label: "", options: [] }],
      searchKeyword: "",
      searchBoxWidth: "30%",
    };
  }

  updateDimensions() {
    const els = document.getElementsByClassName("industry-label");
    const searchEls = document.getElementsByClassName("search");
    const inEls = document.getElementsByClassName("ac-client-in");
    const containerEls = document.getElementsByClassName("ac-clients-industry");
    if (containerEls.length > 0) {
      const w =
        containerEls[0].offsetWidth -
        130 -
        els[0].offsetWidth -
        searchEls[0].offsetWidth -
        inEls[0].offsetWidth;
      this.setState({
        searchBoxWidth: w + "px",
      });
    } else {
      this.setState({
        searchBoxWidth: "30%",
      });
    }
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions.bind(this));
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.industryOptions.length > 0) {
      this.setState({
        value: "",
      });

      let industryGroup = groupBy(nextProps.industryOptions, "group");
      let obj = [];
      obj.push({
        label: "All Industries",
        options: [
          {
            label: "All Industries",
            value: "",
          },
        ],
      });
      for (let x in industryGroup) {
        obj.push({
          label: x,
          options: industryGroup[x],
        });
      }
      this.setState({
        industryGroupObj: obj,
        value: obj[0],
      });
    }
  }
  handleChange(value) {
    this.setState({
      value,
    });
  }

  handleKeywordChange(item) {
    this.setState({
      searchKeyword: typeof item[0] !== "undefined" ? item[0].name : "",
    });
  }
  handleSearch() {
    this.props.handleSearch(this.state.searchKeyword, this.state.value);
  }
  render() {
    const data = this.props.tableAllData;
    return (
      <div className="ac-clients-industry clearfix">
        <label htmlFor="" className="industry-label">
          {/^administrator/gi.test(this.props.roleName)
            ? "Business Unit Search"
            : "Client Search"}
        </label>
        <div className="search">
          <Typeahead
            key="city_search_box"
            labelKey="name"
            multiple={false}
            options={data || [{ name: "" }]}
            placeholder="Find a Client"
            onChange={selectedItem => this.handleKeywordChange(selectedItem)}
          />
        </div>
        <span
          className="ac-client-in"
          style={{
            margin: /^administrator/gi.test(this.props.roleName)
              ? "1em 0.3em 0"
              : "",
          }}
        >
          in
        </span>
        <div
          className="ac-clients-select-filed"
          style={{ border: "none", width: this.state.searchBoxWidth }}
        >
          <Select
            className="industry-group-index"
            clearable={false}
            onChange={value => this.handleChange(value)}
            options={this.state.industryGroupObj}
            value={this.state.value}
          />
        </div>
        <div
          key="city_search_text"
          className="search-button"
          onClick={() => this.handleSearch()}
        >
          <Search style={{ color: "white" }} />
        </div>
      </div>
    );
  }
}

export default Industry;



// WEBPACK FOOTER //
// ./src/components/Clients/Industry.jsx